var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px !important","margin":"0"}},[_c('Categories',{staticClass:"col-sm-12"}),_c('Overview',{staticClass:"col-sm-12"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }